import { IFilter, IFilterOption } from '../../interfaces/Filter.interfaces';
import { directDealFilterSliderConstant } from './slider/directDealFilterSliderConstant';

export interface IDirectDealFilterOption extends IFilterOption {
  value: DirectDealFilterOptionValueType;
  description?: string;
}

export type directDealFilterKeyType =
  | 'sorter'
  | 'filter_brand'
  | 'engineOutputInPs'
  | 'price'
  | 'status'
  | 'machineType'
  | 'rowConfig'
  | 'operationTime'
  | 'manufacturedYear'
  | 'region'
  | 'recentDays';

export interface IDirectDealFilter extends IFilter {
  key: directDealFilterKeyType;
  options: IDirectDealFilterOption[];
}

export enum DirectDealFilterOptionValueSorterEnum {
  default_desc = 'default_desc',
  price_desc = 'price_desc',
  price_asc = 'price_asc',
  manufacturedYear_desc = 'manufacturedYear_desc',
  operationTime_asc = 'operationTime_asc',
}

type DirectDealFilterOptionValueType = DirectDealFilterOptionValueSorterEnum | string | number;

const directDealFilterSorterConstant: IDirectDealFilter = {
  key: 'sorter',
  title: '정렬',
  optionType: 'radio',
  options: [
    {
      optionName: '최신 등록순',
      value: DirectDealFilterOptionValueSorterEnum.default_desc,
      isDefault: true,
      isSelected: true,
    },
    {
      optionName: '높은 가격순',
      value: DirectDealFilterOptionValueSorterEnum.price_desc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '낮은 가격순',
      value: DirectDealFilterOptionValueSorterEnum.price_asc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '최신 연식순',
      value: DirectDealFilterOptionValueSorterEnum.manufacturedYear_desc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '사용시간 적은순',
      value: DirectDealFilterOptionValueSorterEnum.operationTime_asc,
      isDefault: false,
      isSelected: false,
    },
  ],
};

const directDealFilterPriceConstant: IDirectDealFilter = {
  key: 'price',
  title: '가격',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: directDealFilterSliderConstant.price.min,
      defaultValue: directDealFilterSliderConstant.price.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: directDealFilterSliderConstant.price.max,
      defaultValue: directDealFilterSliderConstant.price.max,
      isSelected: true,
    },
  ],
};

const directDealFilterEngineOutputInPsConstant: IDirectDealFilter = {
  key: 'engineOutputInPs',
  title: '마력',
  buttonTitle: '마력 · 조식',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: directDealFilterSliderConstant.engineOutputInPs.min,
      defaultValue: directDealFilterSliderConstant.engineOutputInPs.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: directDealFilterSliderConstant.engineOutputInPs.max,
      defaultValue: directDealFilterSliderConstant.engineOutputInPs.max,
      isSelected: true,
    },
  ],
};

const directDealFilterOperationTimeConstant: IDirectDealFilter = {
  key: 'operationTime',
  title: '사용시간',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: directDealFilterSliderConstant.operationTime.min,
      defaultValue: directDealFilterSliderConstant.operationTime.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: directDealFilterSliderConstant.operationTime.max,
      defaultValue: directDealFilterSliderConstant.operationTime.max,
      isSelected: true,
    },
  ],
};

const directDealFilterManufacturedYearConstant: IDirectDealFilter = {
  key: 'manufacturedYear',
  title: '연식',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: directDealFilterSliderConstant.manufacturedYear.min,
      defaultValue: directDealFilterSliderConstant.manufacturedYear.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: directDealFilterSliderConstant.manufacturedYear.max,
      defaultValue: directDealFilterSliderConstant.manufacturedYear.max,
      isSelected: true,
    },
  ],
};

// 서울·광역시·세종은 서버에서 인접한 도에 포함해 조회한다.
const directDealFilterRegionConstant: IDirectDealFilter = {
  key: 'region',
  title: '지역',
  optionType: 'checkbox',
  options: [
    {
      optionName: '경기',
      value: '경기',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '강원',
      value: '강원',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '충북',
      value: '충북',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '충남',
      value: '충남',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '전북',
      value: '전북',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '전남',
      value: '전남',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '경북',
      value: '경북',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '경남',
      value: '경남',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '제주',
      value: '제주',
      isDefault: false,
      isSelected: false,
    },
  ],
};

export const DIRECT_DEAL_RECENT_DAYS = 7;

const directDealFilterRecentDaysConstant: IDirectDealFilter = {
  key: 'recentDays',
  title: '등록 기간',
  optionType: 'checkbox',
  options: [
    {
      optionName: `최근 ${DIRECT_DEAL_RECENT_DAYS}일`,
      value: DIRECT_DEAL_RECENT_DAYS,
      isDefault: false,
      isSelected: false,
    },
  ],
};

// 아무것도 선택하지 않으면 판매 상태 전체를 조회한다.
const directDealFilterStatusConstant: IDirectDealFilter = {
  key: 'status',
  title: '판매 상태',
  optionType: 'checkbox',
  options: [
    {
      optionName: '판매 중',
      value: 'ONSALE',
      isDefault: true,
      isSelected: true,
    },
    {
      optionName: '판매 완료',
      value: 'SOLDOUT',
      isDefault: false,
      isSelected: false,
    },
  ],
};

const directDealFilterBrandConstant: IDirectDealFilter = {
  key: 'filter_brand',
  title: '브랜드',
  buttonTitle: '브랜드로 보기',
  optionType: 'checkbox',
  options: [],
};

// 아무것도 선택하지 않으면 농기계 전체를 조회한다.
const directDealFilterMachineTypeConstant: IDirectDealFilter = {
  key: 'machineType',
  title: '농기계',
  optionType: 'checkbox',
  options: [
    {
      optionName: '트랙터',
      value: 'tractor',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '콤바인',
      value: 'combine',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '이앙기',
      value: 'transplanter',
      isDefault: false,
      isSelected: false,
    },
  ],
};

const directDealFilterRowConfigConstant: IDirectDealFilter = {
  key: 'rowConfig',
  title: '조식',
  optionType: 'checkbox',
  options: [
    {
      optionName: '2~4조식',
      value: '2_4',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '5~8조식',
      value: '5_8',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '보통형',
      value: 'common',
      isDefault: false,
      isSelected: false,
    },
  ],
};

// 알약 필터와 바텀시트 항목이 이 순서대로 나온다.
export const directDealFiltersConstant: IDirectDealFilter[] = [
  directDealFilterMachineTypeConstant,
  directDealFilterBrandConstant,
  directDealFilterEngineOutputInPsConstant,
  directDealFilterRowConfigConstant,
  directDealFilterPriceConstant,
  directDealFilterManufacturedYearConstant,
  directDealFilterRegionConstant,
  directDealFilterOperationTimeConstant,
  directDealFilterStatusConstant,
  directDealFilterSorterConstant,
  directDealFilterRecentDaysConstant,
];
